<template>
    <div class="TxProductSettingsPortal" v-if="$root.env !== 'renderer'">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "TxProductSettingsPortal",
        mounted() {
            if (this.$root.env === 'frontend') {
                document.body.querySelector('form.variations_form').insertBefore(this.$el, document.body.querySelector('form .variations'));
            }
        }
    }
</script>

<style scoped>

</style>